import { c as _c } from "react/compiler-runtime";
import type { HistoryChangeGroup } from '../history-utils/types.ts';
import { ChangeRow } from './history-change-row.tsx';
import { GroupedChangeRow } from './history-grouped-change-row.tsx';
export const ChangeGroup = t0 => {
  const $ = _c(4);
  const {
    group
  } = t0;
  if (group.entries.length === 1) {
    let t1;
    if ($[0] !== group.entries[0]) {
      t1 = <ChangeRow entry={group.entries[0]} />;
      $[0] = group.entries[0];
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== group) {
    t1 = <GroupedChangeRow group={group} data-sentry-element="GroupedChangeRow" data-sentry-component="ChangeGroup" data-sentry-source-file="history-change-group.tsx" />;
    $[2] = group;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};